import React from 'react'
import { Select } from '@asad/ui'
import plFlag from '@app/assets/icons/pl.svg'
import gbFlag from '@app/assets/icons/gb.svg'

import i18n from '@/i18n'

const LANGUAGES = [
  { id: 'pl', icon: plFlag, name: 'PL' },
  { id: 'en', icon: gbFlag, name: 'EN' },
]

type LanguageItem = { id: string; icon?: string; name?: string }

const getInitialLang = () => {
  try {
    const storedLanguage = typeof window !== 'undefined' ? localStorage.getItem('lng') : null
    const lang = storedLanguage || (i18n && i18n.language) || 'pl'
    return (LANGUAGES.find((l) => l.id === lang) as LanguageItem) || (LANGUAGES[0] as LanguageItem)
  } catch (e) {
    return LANGUAGES[0] as LanguageItem
  }
}

const LangueSelector = () => {
  const [selectedValue, setSelectedValue] = React.useState<LanguageItem>(() => getInitialLang())

  const handleSelect = (item: LanguageItem) => setSelectedValue(item)

  React.useEffect(() => {
    if (!selectedValue) return
    try {
      i18n.changeLanguage(selectedValue.id)
      if (typeof window !== 'undefined') localStorage.setItem('lng', selectedValue.id)
    } catch (e) {}
  }, [selectedValue])

  return (
    <Select
      className='border !border-zinc-800 w-fit bg-black/80 text-slate-100 rounded-md px-2 py-1 ring-1 ring-white/10'
      contentClassName='border !border-zinc-800 bg-black/90 text-slate-100'
      items={LANGUAGES}
      selected={selectedValue}
      setSelected={handleSelect}
      renderItem={(item) => (
        <div className='flex items-center gap-2'>
          <img src={item.icon} alt={item.name} className='w-5 h-5' />
          <span>{item.name}</span>
        </div>
      )}
      renderSelected={(item) => (
        <div className='flex items-center gap-2 text-sm'>
          <div className='flex items-center gap-2'>
            <img src={item.icon} alt={item.name} className='w-4 h-4 rounded-sm' />
            <span className='uppercase'>{item.id}</span>
          </div>
          <div className='h-5 w-px bg-white/20 mr-1' />
        </div>
      )}
    />
  )
}

export default LangueSelector
